<template>
  <div id="app"  >


    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>


  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        localUrl: window.location.href,
        recordNum: 17025202, //备案号
      }
    },
    created() {
      // if(this.localUrl.indexOf('yongwangkeji.cn')>=0){
      //   this.recordNum = '17025202';
      // }else if(this.localUrl.indexOf('localhost')>=0){
      //   this.recordNum = 'akhfaks1241412';
      // }else{
      //   this.recordNum = 'akhfaks';
      // }
    }
  }
  // document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
</script>

<style>
  /*@import "assets/css/bootstrap.css";*/



  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s ease;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  /*body {*/
    /*font-family: 'TengXiangJiaLiZhunCuYuanJian', 'PingFang SC', 'Microsoft Yahei', '黑体';*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/App.vue